import { render, staticRenderFns } from "./StornoSummaryBrowser.vue?vue&type=template&id=7766da88&scoped=true&"
import script from "./StornoSummaryBrowser.vue?vue&type=script&lang=ts&"
export * from "./StornoSummaryBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./StornoSummaryBrowser.vue?vue&type=style&index=0&id=7766da88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7766da88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
